import { Link, Outlet } from "react-router-dom";
import "./navbar.css";
import { useEffect } from "react";

export default function Layout({ branchName }) {
  const navs = ["Menu", "History"];

  useEffect(() => {
    const splash = document.getElementById("splash-screen");
    if (splash) {
      splash.classList.toggle("show", true);
      setTimeout(() => {
        splash.classList.toggle("show", false);
      }, 3000);
    }
  }, []);

  return (
    <>
      <div className="App">
        <header>
          <Link to="/">
            <img
              src={
                "https://pub-a3772f2b02704b91829728f4cc7bbe15.r2.dev/logo(new).svg"
              }
              className="App-logo"
              alt="logo"
            />
          </Link>
          <p className="header-text">
            MAED | <span id="location">{branchName}</span>
          </p>
        </header>

        <Outlet />

        <footer>
          {navs.map((nav, index) => {
            return (
              <NavBtn
                key={index}
                link={`/${nav.toLowerCase()}`}
                name={nav}
                perlogo={`./images/${nav.toLowerCase()}.webp`}
              />
            );
          })}
        </footer>

        <div className="splash-image show " id="splash-screen">
          <img
            src={"./images/comp-logo.webp"}
            className="splash mylogo"
            alt="splash"
          />
          <p>Powered By :</p>
          <div>
            <img src={"/images/coca.webp"} className="splash" alt="logo" />
          </div>
        </div>
      </div>
    </>
  );
}

function NavBtn({ name, perlogo, link }) {
  return (
    <Link to={name === "Menu" ? "/" : link} className={"navbar"} data-id={name}>
      {name === "Cart" ? <span id="item-count">0</span> : ""}
      <img src={perlogo} className="item-logo" alt="logo" />
      <span style={{ display: "block" }}>{name}</span>
    </Link>
  );
}
